import { useContext, useEffect } from 'react';
import InpageModuleContext from 'ContentEditorUI/context/InpageModuleContext';
// @ts-expect-error not typed
import bus from 'ContentEditorUI/coffee/lib/eventBus';

/**
 * Provides context on whether a module within the inpage preview
 * is an inline editable scp module. We close the sidebar when these are selected
 * and provide options within the content tree for inserted modules with SCP richtext modules.
 */
function useInpageModuleRefs() {
  const {
    updateModuleRef,
    getModuleRefs
  } = useContext(InpageModuleContext);
  useEffect(() => {
    bus.on('post:InpageModuleContext:updateModuleRef', message => {
      const {
        payload
      } = message;
      updateModuleRef(payload.widget.id, payload);
    });
  }, [updateModuleRef]);
  return getModuleRefs();
}
export default useInpageModuleRefs;